import type { WindowWithClientData } from '@gumtree/shared/src/types/window';
import getUrlParameter from './extract-url-parameter';

export const extractPageData = (window: WindowWithClientData) => ({
    device: window.clientData.baseConfig.device.type!,
    pageType: window.clientData.baseConfig.pageType,
    breadcrumbs: 'breadcrumbs' in window.clientData ? window.clientData.breadcrumbs : undefined,
    googlePpcVisit: getUrlParameter(window.location.search, 'utm_medium') === 'cpc',
    criteoPpcVisit: getUrlParameter(window.location.search, 'utm_source') === 'Criteo',
    currentPage:
        'resultsPage' in window.clientData
            ? window.clientData.resultsPage.adsPagination.currentPage
            : undefined,
    numberOfResults:
        'resultsPage' in window.clientData
            ? window.clientData.resultsPage?.searchAds?.length
            : undefined,
    l1Category:
        'displayAds' in window.clientData
            ? window.clientData.displayAds?.config?.l1Category
            : undefined,
    l2Category:
        'displayAds' in window.clientData
            ? window.clientData.displayAds?.config?.l2Category
            : undefined,
});
